import React from 'react';
import request from 'request';
import dayjs from 'dayjs';
import { Link } from "react-router-dom";
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Switch from '@material-ui/core/Switch';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

import ErrorIcon from '@material-ui/icons/ErrorOutline';
import LinkIcon from '@material-ui/icons/Link';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import Header from './Header';

import './Main.css';

const LIMIT = 25;

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#f5f5f5',
      light: '#ffffff',
      dark: '#c2c2c2'
    },
    secondary: {
      main: '#29b6f6',
      light: '#73e8ff',
      dark: '#0086c3'
    },
  },
  typography: {
    useNextVariants: true,
  },
});

class Job extends React.Component {
  state = {
    text: '',
    model: '',
    infoStatus: 'Fetching information',
    audioStatus: 'Checking generation status',
    serverError: false,
    link: ''
  }

  fetchInformation = () => {
    request.post({
      url: `${document.location.protocol}//${document.location.host}/api/get_info`,
      json: true,
      body: {
        'job_id': this.props.id,
      }},
      (error, response, body) => {
      if (error) {
        this.setState({serverError: true, infoStatus: "Failed to connnect to server"})
        console.log(error)
        return
      }

      if (body['success']) {
        this.setState({
          text: body['text'],
          model: body['model'],
          creationDate: body['creation_date'],
          infoStatus: ''
        })
      } else {
        this.setState({serverError: true, infoStatus: body['error']})
        setTimeout(() => this.props.removeJob(this.props.public, this.props.id), 2000)
      }
     }
   )
  }

  fetchStatus = () => {
    request.post({
      url: `${document.location.protocol}//${document.location.host}/api/get_status`,
      json: true,
      body: {
        'job_id': this.props.id,
      }},
      (error, response, body) => {
        if (error) {
          this.setState({serverError: true, audioStatus: "Failed to connnect to server"})
          console.log(error)
          return
        }

        if (body['success'] && body['status'] === 'Done') {
          this.setState({audioStatus: ''})
        } else if (body['success']) {
          this.setState({audioStatus: body['status']})
          setTimeout(this.fetchStatus, 1000)
        } else {
          if (body['fatal']) {
            // Fatal error, show message and remove job from list
            this.setState({serverError: true, audioStatus: body['error']});
            setTimeout(() => this.props.removeJob(this.props.public, this.props.id), 3000);
          } else {
            // Non-fatal error, keep job in list with error message
            this.setState({audioStatus: body['error']});
            console.log(body['traceback']);
          }
        }
      }
    )
  }

  handleCopyLink = () => {
    this.setState({link: `/task/${this.props.id}`})
  }

  componentDidMount() {
    this.fetchInformation()
    this.fetchStatus()
  }

  render() {
    let formattedDate = dayjs(this.state.creationDate).format('DD MMM, YYYY HH:mm A')
    let jobBody = (
      <div style={{display: 'flex', flexDirection: 'column', height: '80px', justifyContent: 'center'}}>
        <Typography variant="body1" style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
          <ErrorIcon />
          &nbsp;
          {this.state.audioStatus}
        </Typography>
      </div>
    )

    if (!this.state.serverError) {
      jobBody = (
        <div style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
          <div style={{display: 'flex', flexDirection: 'row', flexGrow: '0'}}>
            <Typography variant="button"> Model: </Typography>
            &nbsp; &nbsp;
            <Typography variant="body1"> {this.state.infoStatus || this.state.model} </Typography>
          </div>
          <div style={{display: 'flex', flexDirection: 'row', flexGrow: '1'}}>
            <Typography variant="button"> Text: </Typography>
            &nbsp; &nbsp;
            <Typography variant="body1" paragraph  style={{textAlign: 'left'}}> {this.state.infoStatus || this.state.text} </Typography>
          </div>
          {this.state.audioStatus}
          {this.state.audioStatus.length === 0 && <audio controls preload="none" style={{width: '100%'}} src={`${document.location.protocol}//${document.location.host}/api/audio/${this.props.id}.wav`}></audio>}
          <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <Typography variant="caption" style={{flexGrow: '1', textAlign: 'left'}}> {this.state.infoStatus || formattedDate} </Typography>
            <Button style={{fontSize: '0.75rem'}} onClick={this.handleCopyLink}> <LinkIcon /> &nbsp; Share </Button>
          </div>
          {this.state.link.length !== 0 &&
            <Paper>
              <Typography variant="overline"> <Link to={this.state.link}>{`${document.location.origin}${this.state.link}`}</Link> </Typography>
            </Paper>
          }
        </div>
      )
    }
    return (
      <Paper style={{
        backgroundColor: "rgb(227, 236, 251)",
        minHeight: '80px',
        marginTop: '10px',
        padding: '10px'
        }}>
        {jobBody}
      </Paper>
    )
  }
}

class Main extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired
  };

  state = {
    // Render vars
    text: '',
    helperText: `0/${LIMIT}`,
    model: '',
    modelList: [],
    public: false,
    jobsView: 'public',
    // Error vars
    serverError: false,
    textError: null,
    modelListError: null,
    // Job vars
    publicJobs: [],
    currentPage: 1,
    totalPages: 1,
    privateJobs: this.props.cookies.get('localjobs') || []
  }

  validateInputText = (text) => {
    if (text.trim().length === 0) {
      return 'Please enter some text'
    } 
    //else if (text.search(/[\u0660-\u0669\d]/) !== -1) {
    //  return 'Digits are currently not supported, please spell out numbers in the text'
    //}

    return null
  }

  handleInputText = (event) => {
    if (event.target.value.split(' ').length > LIMIT) return;

    this.setState({
      text: event.target.value,
      helperText: `${event.target.value.split(' ').length}/${LIMIT}`
    });
  }

  handleModelSelect = (event) => {
    this.setState({ model: event.target.value });
  }

  handleGenerate = () => {
    // Check if input in valid
    let modelListError = null
    let textError = this.validateInputText(this.state.text)

    if (this.state.model === '') {
      modelListError = 'Please select a model'
    }

    if (textError !== null || modelListError !== null) {
      this.setState({textError: textError, modelListError: modelListError})
      return
    }

    // TODO: Disable button while submitting

    // Submit job to server
    let newJob = {
      'model_id': this.state.model,
      'text': this.state.text,
      'is_public': this.state.public
    }

    this.setState({textError: null, modelListError: null, jobsView: (this.state.public?"public":"private")});

    request.post({
      url: `${document.location.protocol}//${document.location.host}/api/submit_job`,
      json: true,
      body: {
          'model_id': newJob.model_id,
          'text': newJob.text,
          'is_public': newJob.is_public
        }
      },
      (error, response, body) => {
        if (error) {
          console.log('Error submitting job')
          console.log(error)

          this.setState({serverError: true})
          return
        }
        if (body['success']) {
          if (newJob.is_public) {
            let newJobs = [body['job_id'], ...this.state.publicJobs];
            this.setState({publicJobs: newJobs});
          } else {
            let newJobs = [body['job_id'], ...this.state.privateJobs];
            this.props.cookies.set('localjobs', newJobs, { path: '/' })
            this.setState({privateJobs: this.props.cookies.get('localjobs')});
          }
        }
      }
    )
  }

  fetchModelList = () => {
    request.post(`${document.location.protocol}//${document.location.host}/api/get_models`,
      (error, response, body) => {
        if (error) {
          console.log("Error fetching model list")
          console.log(error)

          this.setState({serverError: true})
          return
        }
        body = JSON.parse(body)
        if (body["success"] && body["model_list"].length > 0) {
          this.setState({
            modelList: body["model_list"].map((o) => ({
              ...o,
              ...{value: o['id'], key: o['id']}
            }))
          })
        } else {
          this.setState({
            modelList: null
          })
        }
      }
    )
  }

  fetchJobsList = (page_number) => {
    // TODO: Handle cases where duplicate jobs exist because of page
    // boundaries
    request.post({
        url: `${document.location.protocol}//${document.location.host}/api/get_jobs`,
        json: true,
        body: {
          'page': page_number,
        }
      },
      (error, response, body) => {
        if (error) {
          console.log("Error fetching jobs list")
          console.log(error)

          this.setState({serverError: true})
          return
        }

        if (body["success"] && body["job_list"].length > 0) {
          this.setState({
            publicJobs: [...this.state.publicJobs, ...body["job_list"]],
            totalPages: body["total_pages"]
          })
        } else {
          this.setState({
            publicJobs: [],
            totalPages: 1
          })
        }
      }
    )
  }

  handleLoadMorePublicJobs = () => {
    this.fetchJobsList(this.state.currentPage + 1);
    this.setState({currentPage: this.state.currentPage + 1});
  }

  removeJob = (jobType, jobid) => {
    let currentJobList = this.state.publicJobs;
    if (jobType == 'private') {
      currentJobList = this.state.privateJobs;
    }
    let jobIdx = currentJobList.indexOf(jobid)
    if ( jobIdx !== -1 ) {
      let newJobs = [
        ...currentJobList.slice(0, jobIdx),
        ...currentJobList.slice(jobIdx+1, currentJobList.length)
      ]

      if (jobType == 'public') {
        this.setState({publicJobs: newJobs});
      } else {
        this.props.cookies.set('localjobs', newJobs, { path: '/' });
        this.setState({privateJobs: this.props.cookies.get('localjobs')});
      }
    }
  }

  componentDidMount() {
    this.fetchModelList()
    this.fetchJobsList(1)
  }

  render() {
    console.log("private:", this.state.privateJobs);
    console.log("public:", this.state.publicJobs);

    let modelsDiv = (
      <div style={{display: 'flex', flexDirection:'row', flexGrow: 1, alignItems: 'center', justifyContent: 'center'}}>
        <p> Loading available models </p>
        <span> &nbsp; &nbsp; &nbsp; &nbsp; </span>
        <CircularProgress color="secondary" />
      </div>
    )

    if (this.state.modelList == null) {
      modelsDiv = (
        <div style={{display: 'flex', flexDirection:'row', flexGrow: 1, alignItems: 'center', justifyContent: 'center'}}>
        <p> No models available </p>
        <span> &nbsp; </span>
        <ErrorIcon />
      </div>
      )
    } else if (this.state.modelList.length > 0) {
      modelsDiv = (
        <FormControl error={this.state.modelListError !== null} component="fieldset" style={{'flexGrow': 1, justifyContent: 'center'}}>
          <FormLabel component="legend">Select Model</FormLabel>
          <RadioGroup
            aria-label="Model"
            name="model"
            value={this.state.model}
            onChange={this.handleModelSelect}
            row
          >
            {this.state.modelList.map((m) => (<FormControlLabel key={m.key} value={m.value} control={<Radio />} label={m.name} />))}
          </RadioGroup>
          <FormHelperText> {this.state.modelListError} </FormHelperText>
        </FormControl>
      )
    }

    if (this.state.serverError) {
      modelsDiv = (
        <div style={{display: 'flex', flexDirection:'row', flexGrow: 1, alignItems: 'center', justifyContent: 'center'}}>
        <p> Cannot connect to server </p>
        <span> &nbsp; &nbsp; &nbsp; &nbsp; </span>
        <ErrorIcon />
      </div>
      )
    }
    return (
      <MuiThemeProvider theme={theme}>
        <div className="App">
          <Header />
          <div className="Content">
            <form autoComplete="off" style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
              <TextField
                id="input-text-field"
                label="Enter text here"
                error={this.state.textError !== null}
                multiline
                rows="4"
                value={this.state.text}
                onChange={this.handleInputText}
                margin="normal"
                helperText={this.state.textError || this.state.helperText}
                variant="outlined"
                fullWidth
              />
              <div style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-start'}}>
                {modelsDiv}
                <div style={{minWidth: '180px', height: '50px', paddingTop: '14px', display: 'flex', flexDirection: 'row', justifyContent: 'center', borderLeft: '#333 1px solid', paddingLeft: '20px'}}>
                  <FormGroup row>
                    <Tooltip title="Public submissions are visible to all visitors on this website">
                      <FormControlLabel
                        control={<Switch checked={this.state.public} onChange={() => {this.setState({'public': !this.state.public})}} name="is_public" />}
                        label="Public"
                        style={{paddingRight: "30px"}}
                      />
                    </Tooltip>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={this.handleGenerate}
                    >
                      Generate Speech
                    </Button>
                  </FormGroup>
                </div>
              </div>
            </form>


            <div style={{marginBottom: '50px'}}>
              <Tabs
                value={this.state.jobsView}
                onChange={(e, v) => {this.setState({'jobsView': v})}}
                indicatorColor="secondary"
                textColor="secondary"
                centered
              >
                <Tab label="Public" value="public" />
                <Tab label="Private" value="private" />
              </Tabs>
              <div hidden={this.state.jobsView != "public"}>
                {(this.state.publicJobs.length == 0) && (
                  <Typography variant="subtitle1">
                    No public jobs found
                  </Typography>
                )}
                {this.state.publicJobs.map((j) => (<Job id={j} key={j} public={true} removeJob={this.removeJob} />))}
                {(this.state.currentPage < this.state.totalPages) && (
                  <div style={{marginTop: '10px'}}>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={this.handleLoadMorePublicJobs}
                    >
                      Load more
                    </Button>
                  </div>
                )}
              </div>
              <div hidden={this.state.jobsView != "private"}>
                {(this.state.privateJobs.length == 0) && (<Typography variant="subtitle1">
                  No private jobs found
                </Typography>)}
                {this.state.privateJobs.map((j) => (<Job id={j} key={j} public={false} removeJob={this.removeJob} />))}
              </div>
            </div>

          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default withCookies(Main);
